import { useCallback, useState } from 'react';
import { raiseToast } from '@fiverr-private/toast';
import { globalMixpanelReporter, globalBigQueryReporter, globalGrafanaReporter } from '../../../events';
import { resendEmailWithCode } from '../../../api';

interface UseResendEmailWithCode {
    email: string;
    setShowResendSuccess?: React.Dispatch<React.SetStateAction<boolean>>;
}

export const useResendEmailWithCode = ({ email, setShowResendSuccess }: UseResendEmailWithCode) => {
    const [isResending, setIsResending] = useState(false);
    const resend = useCallback(async () => {
        setIsResending(true);
        globalMixpanelReporter.send('Identification - Activation - Resend Code');
        globalBigQueryReporter.send('identification.activation.resend_code');
        globalGrafanaReporter.count('identification.%{platform}.activation.resend_code');
        const result = await resendEmailWithCode(email);
        if (result.success) {
            setShowResendSuccess?.(true);
        } else if (result.translatedError) {
            raiseToast({ message: result.translatedError, type: 'error', location: 'top-end' });
            setShowResendSuccess?.(false);
        }
        setIsResending(false);
    }, [email, setShowResendSuccess]);

    return {
        isResending,
        resend,
    };
};
